import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMVendorCategoryAsync,
  deleteOMVendorCategoryAsync,
  editOMVendorCategoryAsync,
  getOMVendorCategoryAsync,
} from "../../../store/services/orderManagementService";
const VendorCategory = () => {
  const dispatch = useDispatch();
  const {
    getOMVendorCategoryStatus,
    getOMVendorCategoryError,
    getOMVendorCategoryData,
    addOMVendorCategoryStatus,
    addOMVendorCategoryData,
    addOMVendorCategoryError,

    editOMVendorCategoryStatus,
    editOMVendorCategoryError,
    editOMVendorCategoryData,

    deleteOMVendorCategoryData,
    deleteOMVendorCategoryStatus,
    deleteOMVendorCategoryError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMVendorCategoryAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMVendorCategoryData?.length
    ? getOMVendorCategoryData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedVendorCategory, setSelectedVendorCategory] = useState();
  const [addVendorCategoryMode, setAddVendorCategoryMode] = useState(false);
  const [addVendorCategoryData, setAddVendorCategoryData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedVendorCategory", selectedVendorCategory);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMVendorCategoryStatus === asyncStatus.SUCCEEDED) {
      setAddVendorCategoryMode(false);
      setSaveDisabled(true);
      setAddVendorCategoryData();
    }
  }, [, addOMVendorCategoryStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMVendorCategoryAsync(selectedVendorCategory?.vendor_category_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMVendorCategoryStatus === asyncStatus.SUCCEEDED || deleteOMVendorCategoryStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedVendorCategory();
    }
  }, [, deleteOMVendorCategoryStatus]);
  useEffect(() => {
    if (editOMVendorCategoryStatus === asyncStatus.SUCCEEDED) {
      setSelectedVendorCategory();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMVendorCategoryStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this vendor category?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Vendor Category"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Vendor Category
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddVendorCategoryMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addVendorCategoryMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addVendorCategoryMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddVendorCategoryMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addVendorCategoryMode || !selectedVendorCategory}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMVendorCategoryStatus === asyncStatus.LOADING ||
                  editOMVendorCategoryStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addVendorCategoryData) {
                    dispatch(addOMVendorCategoryAsync(addVendorCategoryData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedVendorCategory, ...editData };
                    delete a.id;
                    dispatch(editOMVendorCategoryAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "vendor_category_id", headerName: "ID", flex: true },
                  { field: "category_name", headerName: "Vendor Category", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedVendorCategory(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMVendorCategoryStatus === asyncStatus.IDLE ||
                  getOMVendorCategoryStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addVendorCategoryMode ? (
              <InputWithBtnLayoutComp
              error={addOMVendorCategoryError}
                inputArray={[
                  {
                    label: "Vendor Category:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddVendorCategoryData({
                            ...addVendorCategoryData,
                            category_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddVendorCategoryData({
                            ...addVendorCategoryData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedVendorCategory ? (
              <InputWithBtnLayoutComp
              error={editOMVendorCategoryError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedVendorCategory?.vendor_category_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Vendor Category:",
                    comp: (
                      <InputComp
                        key={selectedVendorCategory?.vendor_category_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            category_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedVendorCategory?.category_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedVendorCategory?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedVendorCategory?.is_active || editData?.is_active}
                        defaultChecked={selectedVendorCategory?.is_active || editData?.is_active}
                        // checked={selectedVendorCategory?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any vendor category</Typography>
              <Typography color={"red"} fontSize={12}>{getOMVendorCategoryError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedVendorCategory(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedVendorCategory(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default VendorCategory;
